import { Link } from "react-router-dom";
import classNames from "./Footer.module.css";
import logo from "../../../assets/logo_with_text.svg";
// import { useLogEvent } from "../../../hooks/log";

const Footer = () => {
  // const logEvent = useLogEvent();
  return (
    <section className={classNames.Footer}>
      <div>
        <div className={classNames.FooterLogo}>
          <img src={logo} alt="Langfinity" />
        </div>
        <div className={classNames.Links}>
          <div>
            <div className={classNames.LinksTitle}>RESOURCES</div>
            <Link to="/faq">FAQ</Link>
            <Link to="/customer-stories">Customer stories</Link>
            {/* <Link
              to="https://langfinity.ai/blog/"
              target="_blank"
              onClick={() => logEvent({ type: "click_blog_footer" })}
            >
              Blog
            </Link> */}
          </div>
          <div>
            <div className={classNames.LinksTitle}>COMPANY</div>
            <Link to="/about">About</Link>
          </div>
          <div>
            <div className={classNames.LinksTitle}>SOCIALS</div>
            <Link to="https://x.com/LangfinityAI">X</Link>
            <Link to="https://www.linkedin.com/company/langfinity">
              LinkedIn
            </Link>
          </div>
        </div>
      </div>
      <div className={classNames.Legal}>
        <Link to="https://langfinity.ai/terms-of-service/" target="_blank">
          TERMS OF SERVICE
        </Link>
        <Link to="https://langfinity.ai/privacy-policy/" target="_blank">
          PRIVACY POLICY
        </Link>
        <div>© 2025 BYRDHOUSE INC</div>
      </div>
    </section>
  );
};

export default Footer;
